module.exports = __webpack_public_path__ + "static/media/Nguyen_Trong_Tung.aa6bb28c.jpg";